﻿﻿export interface IRecipientCompliance {
    id: number;
    alias: string;
    complianceIssues: string[];
}
